import HomeView from './views/HomeView.vue';
import PricingView from './views/PricingView.vue';
import BlogView from './views/BlogView.vue';
import PostDetailView from './views/PostDetailView.vue';
import PortalFacturacionView from './views/PortalFacturacionView.vue';
import PrivacyPolicyView from './views/PrivacyPolicyView.vue';
import DesarrolloNetSuiteView from './views/DesarrolloNetSuiteView.vue';
import NosotrosView from './views/NosotrosView.vue';
import AIChat from './views/AIChat.vue';
import NetSuiteSolutionView from './views/NetSuiteSolutionView.vue';

export default[
    {path:"/",component:HomeView},
    {path:"/nosotros",component:NosotrosView},
    {path:"/costos",component:PricingView},
    {path:"/blog",component:BlogView},
    {path:"/blog/:slug",component:PostDetailView,name:"post"},
    {path:"/portal-facturacion",component:PortalFacturacionView},
    {path:"/politica-privacidad",component:PrivacyPolicyView},
    {path:"/desarrollo-netsuite",component:DesarrolloNetSuiteView},
    {path:"/pos-netsuite",component:NetSuiteSolutionView,props:{solutionKey:"pos"}},
    {path:"/conciliador-bancario-netsuite",component:NetSuiteSolutionView,props:{solutionKey:"bank"}},
    {path:"/soluciones-fiscales-netsuite",component:NetSuiteSolutionView,props:{solutionKey:"fiscal"}},
    {path:"/chbs-ai-netsuite",component:AIChat}
]